import { render } from "./Snowflake.vue?vue&type=template&id=1a64b916"
const script = {}

import "./Snowflake.vue?vue&type=style&index=0&id=1a64b916&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__